import type { UserPermissions } from 'redux/modules/user.types';
import { UserPermission } from 'redux/modules/user.types';

export const USER_PERMISSION_PRESET_NONE: UserPermissions = {
  account: [],
  company: [],
  forecast: [],
  invoice: [],
  label: [],
  project: [],
  report: [],
  team: [],
  user: [],
  day_property: [],
};

const allPermissions = [...Object.values(UserPermission)];
export const USER_PERMISSION_PRESET_ALL: UserPermissions = {
  account: allPermissions,
  company: allPermissions,
  forecast: allPermissions,
  invoice: allPermissions,
  label: allPermissions,
  project: allPermissions,
  report: allPermissions,
  team: allPermissions,
  user: allPermissions,
  day_property: allPermissions,
};

/**
 * Based on the info found here:
 * https://docs.google.com/spreadsheets/d/13EAi7ohXsAUKoP3-wIGwjsoWhW_8jOygZr9kph7TVaU/edit#gid=1306461073
 */
export const USER_PERMISSION_PRESET_LIMITED: UserPermissions = {
  account: [UserPermission.Create, UserPermission.Read],
  company: [],
  forecast: [],
  invoice: [],
  label: [UserPermission.Read],
  project: [UserPermission.Read],
  report: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
    UserPermission.ChangeOwnership,
    UserPermission.Notify,
  ],
  team: [],
  user: [UserPermission.Read],
  day_property: [],
};

/**
 * Based on the info found here:
 * https://docs.google.com/spreadsheets/d/13EAi7ohXsAUKoP3-wIGwjsoWhW_8jOygZr9kph7TVaU/edit#gid=1306461073
 */
export const USER_PERMISSION_PRESET_NORMAL: UserPermissions = {
  account: [UserPermission.Create, UserPermission.Read],
  company: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  forecast: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  invoice: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  label: [UserPermission.Read],
  project: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  report: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  team: [UserPermission.Read],
  user: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
    UserPermission.Notify,
  ],
  day_property: [],
};

/**
 * Based on the info found here:
 * https://docs.google.com/spreadsheets/d/13EAi7ohXsAUKoP3-wIGwjsoWhW_8jOygZr9kph7TVaU/edit#gid=1306461073
 */
export const USER_PERMISSION_PRESET_ADMIN: UserPermissions = {
  account: [UserPermission.Create, UserPermission.Read, UserPermission.Update],
  company: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  forecast: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  invoice: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  label: [UserPermission.Create, UserPermission.Read, UserPermission.Update, UserPermission.Delete],
  project: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  report: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  team: [UserPermission.Create, UserPermission.Read, UserPermission.Update, UserPermission.Delete],
  user: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
    UserPermission.Notify,
  ],
  day_property: [UserPermission.Create, UserPermission.Update],
};

/**
 * Based on the info found here:
 * https://docs.google.com/spreadsheets/d/13EAi7ohXsAUKoP3-wIGwjsoWhW_8jOygZr9kph7TVaU/edit#gid=1306461073
 */
export const USER_PERMISSION_PRESET_OWNER: UserPermissions = {
  account: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
    UserPermission.ChangeOwnership,
    UserPermission.ManageSubscriptions,
    UserPermission.ManageDev,
  ],
  company: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  forecast: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  invoice: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  label: [UserPermission.Create, UserPermission.Read, UserPermission.Update, UserPermission.Delete],
  project: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  report: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
  ],
  team: [UserPermission.Create, UserPermission.Read, UserPermission.Update, UserPermission.Delete],
  user: [
    UserPermission.Create,
    UserPermission.Read,
    UserPermission.Update,
    UserPermission.Delete,
    UserPermission.Notify,
  ],
  day_property: [],
};

/**
 * These are the permissions applied before the application has finished loading the
 * actual permissions of the user.
 */
export const DEFAULT_USER_PERMISSIONS = USER_PERMISSION_PRESET_NONE;
